export var getAeroexpressProductId = function (trip) { return "".concat(trip.id).concat(trip.class).concat(trip.departureDate); };
export var isSelectedTrip = function (trip) {
    return trip.hasOwnProperty('tickets');
};
